<rav-modal modalId="importFiles" modalTitle="Import Files">
  <form [formGroup]="formGroup" novalidate>
    <div *ngIf="filesTooLarge.length > 0" class="small callout alert">{{ filesTooLargeMessage }}</div>
    <div *ngIf="invalidFiles.length > 0" class="small callout alert">{{ nonPdfFilesMessage }}</div>
    <div *ngIf="errorMessage" class="small callout alert">{{ errorMessage }}</div>
    <div *ngIf="!hasCorrectMinFilename" class="small callout alert">{{ hasCorrectMinFilenameMessage }}</div>
    Import PDF, JPEG, or TIFF documents up to 30MB in size.
    <input
      #fileSelect
      type="file"
      class="padding-top-1"
      (change)="filesSelected($event)"
      placeholder="Upload file"
      accept=".pdf,.jpg,.jpeg,.tiff,.tif"
      data-cy="file-import"
      files="selectedFiles"
      formControlName="file"
      multiple
    />

    <div class="flex-container align-middle">
      <button
        (click)="modal.open.next({ modalId: 'selectFolder' })"
        class="button select-folder__button"
        [class.hollow]="selectedFolder"
      >
        Select Folder
      </button>
      <span
        *ngIf="selectedFolder"
        class="sidebar__link secondary-color tree__node-link margin-left-1"
        data-cy="selected-folder"
      >
        <div class="flex-container align-middle">
          <rav-icon name="folder" class="sidebar__icon"></rav-icon>
          <span class="tree__node-text">{{ selectedFolder.title }} </span>
        </div>
      </span>
    </div>

    <div class="flex-container align-right">
      <button
        [disabled]="
          !selectedFolder ||
          !isFileSelected ||
          filesTooLarge.length > 0 ||
          invalidFiles.length > 0 ||
          !hasCorrectMinFilename
        "
        (click)="onImportButtonClicked()"
        class="button"
      >
        Import
      </button>
    </div>
  </form>
</rav-modal>

<rav-folder-select
  [addInboxNode]="true"
  modalId="selectFolder"
  (folderChosen)="folderSelected($event)"
></rav-folder-select>
